import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    commonDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    paymentMode: {
      type: Array,
      default: function _default() {
        return new Array();
      }
    }
  },
  watch: {
    paymentMode: {
      deep: true,
      immediate: true,
      handler: function handler(param) {
        this.paymentModeList = param;
      }
    }
  },
  data: function data() {
    return {
      pageLoading: false,
      paymentModeList: [{
        text: null
      }]
    };
  },
  methods: {
    updatePaymentMode: function updatePaymentMode() {
      var _this = this;

      _this.pageLoading = true;

      _this.$store.dispatch(PATCH, {
        url: "setting/payment-mode",
        data: {
          payment_mode: _this.paymentModeList
        }
      }).then(function () {
        _this.$emit("close-dialog", true);

        _this.$emit("get-payment-mode", true);
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    createPaymentMode: function createPaymentMode() {
      this.paymentModeList.push({
        text: null
      });
    },
    deletePaymentMode: function deletePaymentMode(index) {
      if (this.paymentModeList.length > 1) {
        this.paymentModeList.splice(index, 1);
      }
    }
  },
  components: {
    Dialog: Dialog
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.lodash.toSafeInteger(document.body.clientWidth / 100 * 50);
    }
  }
};